import { appContent } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-5xl">
        <div className="bg-background-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-6 md:p-10 lg:p-12 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-black text-background-50 mb-3">
                {appContent.title}
              </h2>
              <p className="text-sm md:text-base text-background-50/60 leading-relaxed mb-6">
                {appContent.description}
              </p>

              <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
                {appContent.features.map((feat) => (
                  <span
                    key={feat}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/10 text-background-50/80 text-xs font-medium"
                  >
                    <i className="ri-check-line text-primary-400 text-sm"></i>
                    {feat}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <button className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-line mr-2"></i>App Store 下载
                </button>
                <button className="w-full sm:w-auto px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 text-sm font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border border-background-50/20">
                  <i className="ri-android-line mr-2"></i>Android 下载
                </button>
              </div>
            </div>

            <div className="flex-1 p-6 md:p-10 flex justify-center">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden bg-background-800 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50/30 mb-2 block"></i>
                  <span className="text-xs text-background-50/30">扫码下载</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}